import React from 'react'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/Navbar.css'

const Links = {
  blog: 'https://medium.com/@academme',
  facebook: 'https://www.facebook.com/AcademME/',
  linkedin: 'https://www.linkedin.com/company/academme',
  twitter: 'https://twitter.com/Academ_ME'
}

const MobileTextLinks = [
  {
    text: 'HOME',
    url: '/'
  },
  {
    text: 'ABOUT',
    url: '/about'
  },
  {
    text: 'HOW IT WORKS',
    url: '/how'
  },
  {
    text: 'GET THE INVITE',
    url: '/invite'
  }
]

export default class Navbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showConnect: false,
      showMobileMenu: false
    }
  }

  onConnectMouseEnter = ev => {
    this.setState({
      showConnect: true
    })
  }

  onConnectMouseOut = ev => {
    this.setState({
      showConnect: false
    })
  }

  toggleMobileMenu = ev => {
    let showMobileMenu = !this.state.showMobileMenu
    this.setState({
      showMobileMenu
    })
    let visibility = showMobileMenu ? 'visible' : 'hidden'
    document.getElementById('overlay').style.visibility = visibility
  }

  renderConnect = () => (
    <div className="connect-hover-nav"
      onMouseEnter={this.onConnectMouseEnter}
      onMouseLeave={this.onConnectMouseOut}>
      <div className="connect-nav-item">
        <Link to="/connect">EDUCATORS</Link>
      </div>
      <div className="separator">|</div>
      <div className="connect-nav-item">
        <Link to="/connect/employer">EMPLOYERS</Link>
        </div>
      <div className="separator">|</div>
      <div className="connect-nav-item">
        <Link to="/connect/vendor">VENDORS</Link>
      </div>
    </div>
  )
  
  renderMobileLink = link => (
    <div key={link}
      className="mobile-menu-item"
      onClick={this.toggleMobileMenu}>
      <Link to={link.url}>{link.text}</Link>
    </div>
  )
  
  renderMobileMenu = () => (
    <CSSTransitionGroup
      transitionName="drag"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionLeaveTimeout={500}
      transitionEnter={false}
      transitionLeave={true}>
      <div className="mobile-menu">
        {MobileTextLinks.map(this.renderMobileLink)}
        <div className="center">
          <div className="yellow-nav-button orange-button">GET YOUR INVITATION</div>
          {this.renderNavIcons()}
          <div className="mobile-connect">
            <Link to="/connect">CONNECT WITH STUDENTS</Link>
          </div>
        </div>
      </div>
    </CSSTransitionGroup>
  )

  renderIcon = type => (
    <a key={type} href={Links[type]}>
      <div className={`${type} ${this.state.showMobileMenu ? 'mobile-icon' : 'navbar-top-icon'}`} />
    </a>
  )

  renderNavIcons = () => {
    return (
      <div className="nav-icons">
        {Object.keys(Links).map(this.renderIcon)}
      </div>
    )
  }  

  render() {
    let { showMobileMenu, showConnect } = this.state

    return (
      <div className="navbar-top">
        <Link to="/"><div className="logo-mobile nav-logo" /></Link>
        {showConnect ? this.renderConnect() : null}
        {showMobileMenu ? null : this.renderNavIcons()}
        <div className="blog navbar-top-item">
          <a href={Links.blog}>BLOG</a>
        </div>
        <div
          className={`connect navbar-top-item ${showConnect ? 'connect-hover' : null}`}
          onMouseEnter={this.onConnectMouseEnter}
          onMouseLeave={this.onConnectMouseOut}>CONNECT WITH STUDENTS</div> 
        <div className="question-mark"
          onClick={this.toggleMobileMenu} />
        {showMobileMenu ? this.renderMobileMenu() : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/Navbar.js